<template>
	<div
		class="kk-text-field"
		:class="[
			isDisabled && 'kk-text-field--disabled',
			hasError && 'kk-text-field--error',
			leadingIcon && 'kk-text-field--leading',
			hasTrailingIcon && 'kk-text-field--trailing',
			type === 'search' && 'kk-text-field--search',
		]"
		@click="onClickElement"
	>
		<KkIcon
			v-if="leadingIcon"
			:name="leadingIcon"
			size="sm"
			class="kk-text-field__leading-icon"
		/>
		<input
			ref="inputElement"
			v-model="currentValue"
			v-bind="$attrs"
			class="kk-text-field__native"
			:type="type"
			:placeholder="placeholder"
			:autocomplete="autocomplete"
			:disabled="isDisabled"
			@change="onChangeHandler"
			@focus="$emit('focus', $event)"
			@blur="$emit('blur', $event)"
		>
		<div
			v-if="hasTrailingIcon"
			class="kk-text-field__trailing-container"
		>
			<KkAccessibleButton
				v-if="isShowDeleteIcon"
				class="kk-text-field__delete-icon"
				@click="clearInput"
			>
				<KkIcon
					name="ic_crossCircle_fill"
					size="xs"
				/>
			</KkAccessibleButton>
			<KkAccessibleButton
				v-if="trailingIcon"
				class="kk-text-field__trailing-icon"
				@click="$emit('click:trailingIcon')"
			>
				<KkIcon
					:name="trailingIcon"
					size="sm"
				/>
			</KkAccessibleButton>
		</div>
	</div>
</template>

<script>
import KkIcon from '../../KkIcon';
import KkAccessibleButton from '../../KkAccessibleButton';

function initialsToUpperCase(val) {
	return String(val).toLowerCase().replace(/^\S/, s => s.toUpperCase());
}

function nullString(val) {
	if (val === 'null' || val === 'NULL') {
		return initialsToUpperCase(val);
	}
	return val;
}

export default {
	name: 'KkTextField',
	components: {
		KkIcon,
		KkAccessibleButton,
	},
	inheritAttrs: false,
	props: {
		value: {
			type: [String, Number],
			default: '',
		},
		isClearable: {
			type: Boolean,
			default: false
		},
		isDisabled: {
			type: Boolean,
			default: false
		},
		hasError: {
			type: Boolean,
			default: false,
		},
		leadingIcon: {
			type: String,
			default: '',
		},
		trailingIcon: {
			type: String,
			default: '',
		},
		placeholder: {
			type: String,
			default: '',
		},
		autocomplete: {
			type: String,
			default: 'on',
			validator: function (value) {
				return ['off', 'on'].indexOf(value) !== -1
			},
		},
		type: {
			type: String,
			default: 'text', // native input type
		},
	},
	data() {
		return {
			isPasswordVisible: false,
		};
	},
	computed: {
		currentValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit('input', val)
			},
		},
		isShowDeleteIcon() {
			return !this.isDisabled && this.isClearable && this.value.length > 0;
		},
		hasTrailingIcon() {
			return this.isClearable || this.trailingIcon;
		},
	},
	methods: {
		onClickElement() {
			this.$refs.inputElement.focus();
		},
		clearInput() {
			this.$emit('input', '');
		},
		onChangeHandler(event) {
			const result = nullString(event.target.value.trim());

			this.$emit('input', result);
			this.$emit('change', result);
		},
	},
};
</script>
